import React from "react";
import provideDesignTheme from "../providers/ThemeProvider"; //provides a designTheme and designColors props

import ColorPicker from "./ColorPicker";
import { getPaletteColorFromUpdate } from "../../utils/ColorUtils";

const ThemeColorsColorPicker = ({
  onColorChange,
  designColors,
  color,
  palette,
  disabled,
  context,
  ...other
}) => {
  const baseColor = color;
  const _onColorChange = (color, info, addUndo) => {
    const value = getPaletteColorFromUpdate(color, info);
    onColorChange && onColorChange(value, addUndo);
  };

  palette = palette || designColors.toJS();
  let paletteIndex = -1;

  if (color && color.startsWith("colors")) {
    let colorParts = color.split(":");
    let colorVal = colorParts[0];

    let cvp = colorVal.split("-");
    paletteIndex = parseInt(cvp[1]);
    color = palette[paletteIndex];
    if (colorParts.length > 1) {
      color += ":" + colorParts[1];
    }
  }

  return (
    <ColorPicker
      originalColor={baseColor}
      disabled={disabled}
      palette={palette}
      paletteIndex={paletteIndex}
      color={color}
      onColorChange={_onColorChange}
      context={context}
      {...other}
    />
  );
};

export default provideDesignTheme(ThemeColorsColorPicker);
